import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { JoveLogoLoading } from '@jove-frontend/mui';
import { JOVE_DEFAULT_LOCALE_COUNTRY, JOVE_LOCAL_LOCALE_COUNTRY_KEY, supportTranslationCountryConvertMap } from '@jove-frontend/uikit';
import { Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import { useQuoteStripePayment } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var stripeErrorTypeList = ['card_error', 'validation_error'];
var StripePaymentComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var successReturnUrl = props.successReturnUrl,
      isSetupIntent = props.isSetupIntent;
  var stripe = useStripe();
  var elements = useElements();
  /**
   * requests
   */

  var requestPayStripe = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _res;

      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              res = {
                error: null
              };

              if (!isSetupIntent) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return stripe.confirmSetup({
                elements: elements,
                confirmParams: {
                  return_url: successReturnUrl
                }
              });

            case 4:
              res = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.next = 9;
              return stripe.confirmPayment({
                elements: elements,
                confirmParams: {
                  return_url: successReturnUrl
                }
              });

            case 9:
              res = _context.sent;

            case 10:
              return _context.abrupt("return", (_res = res) === null || _res === void 0 ? void 0 : _res.error);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestPayStripe() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    createPaymentElement();
  }, []);
  /**
   * methods
   */

  var createPaymentElement = function createPaymentElement() {
    var paymentElement = elements === null || elements === void 0 ? void 0 : elements.create('payment', {
      paymentMethodOrder: ['card', 'apple_pay', 'google_pay']
    });

    if (paymentElement) {
      paymentElement.mount('#jove-stripe-payment');
    }
  };
  /**
   * External methods
   */


  var payStripe = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!stripe || !elements)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return requestPayStripe();

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function payStripe() {
      return _ref2.apply(this, arguments);
    };
  }();

  useImperativeHandle(ref, function () {
    return {
      payStripe: payStripe
    };
  });
  return /*#__PURE__*/_jsx("div", {
    className: "h-full w-full",
    id: "jove-stripe-payment"
  });
});
export var StripePaymentView = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _supportTranslationCo;

  var clientSecret = props.clientSecret,
      successReturnUrl = props.successReturnUrl,
      payError = props.payError,
      quoteId = props.quoteId,
      stripePayOperationKey = props.stripePayOperationKey,
      isSetupIntent = props.isSetupIntent;
  var stripePaymentRef = useRef(null);

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useQuoteStripePaymen = useQuoteStripePayment(quoteId, {
    stripePayOperationKey: stripePayOperationKey
  }),
      stripePromise = _useQuoteStripePaymen.stripePromise;
  /**
   * requests
   */


  var requestCreateStripePayment = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var error;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.next = 3;
              return stripePaymentRef.current.payStripe();

            case 3:
              error = _context3.sent;
              setLoading(false);

              if (error) {
                payError === null || payError === void 0 ? void 0 : payError(error.message || 'An unexpected error occured.');
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function requestCreateStripePayment() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * methods
   */
  // Create payment


  var createStripePayment = function createStripePayment() {
    requestCreateStripePayment();
  }; //


  useImperativeHandle(ref, function () {
    return {
      createStripePayment: createStripePayment
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "h-full",
    children: [loading && /*#__PURE__*/_jsx(JoveLogoLoading, {}), stripePromise && /*#__PURE__*/_jsx(Elements, {
      stripe: stripePromise,
      options: {
        clientSecret: clientSecret,
        locale: ((_supportTranslationCo = supportTranslationCountryConvertMap[localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY) || JOVE_DEFAULT_LOCALE_COUNTRY]) === null || _supportTranslationCo === void 0 ? void 0 : _supportTranslationCo.stripeLocale) || supportTranslationCountryConvertMap.DEFAULT.stripeLocale
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "relative h-full",
        children: /*#__PURE__*/_jsx(StripePaymentComponent, {
          ref: stripePaymentRef,
          successReturnUrl: successReturnUrl,
          payError: payError,
          isSetupIntent: isSetupIntent
        })
      })
    })]
  });
});